import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'
import Job from './Job'
import Jobs from './Jobs'
import ApplyJob from './ApplyJob'
import TrackApplication from './TrackApplication'
import TrackedApplicationDetails from './TrackedApplicationDetails'

function Career() {
  const location = useLocation()
  const history = useHistory()

  return (
    <>
      {location?.search?.split('=')?.at(0) !== '?track' &&
      !location?.search?.includes('tracking_id') ? (
        <div className='w-100 d-flex my-3'>
          <button
            onClick={() => history.push('/job/career?track')}
            className='btn btn-info  ml-auto'
          >
            Track Application
          </button>
        </div>
      ) : (
        <div className='w-100 d-flex my-3 justify-content-between'>
          {location?.search?.includes('tracking_id') && (
            <h1>Job Application Details</h1>
          )}
          <button
            onClick={() => history.push('/job/career')}
            className='btn btn-info  ml-auto'
          >
            Go to Career Page
          </button>
        </div>
      )}

      {!location?.search && <Jobs />}
      {location?.search && location?.search?.split('=')?.at(0) === '?job' && (
        <Job />
      )}
      {location?.search &&
        location?.search?.split('=')?.at(0) === '?apply_job' && <ApplyJob />}
      {location?.search && location?.search?.split('=')?.at(0) === '?track' && (
        <TrackApplication />
      )}
      {location?.search && location?.search?.includes('tracking_id') && (
        <TrackedApplicationDetails />
      )}
    </>
  )
}

export default Career
